import { render, staticRenderFns } from "./OzBackButton.vue?vue&type=template&id=a1778a54&"
import script from "./OzBackButton.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OzBackButton.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports